import type { RouteRecordRaw } from 'vue-router';

declare module 'vue-router' {
  interface RouteMeta {
    /** 顶部栏显示的页面名（与真实产品的「爆款选题」「文案」「配音」一致） */
    title?: string;
    /** 是否显示左侧图标轨；首页 Hero 不显示 */
    rail?: boolean;
    /** 该路由对应的步骤（用于图标轨高亮） */
    step?: import('@luogen/shared').StepKey;
  }
}

export const routes: RouteRecordRaw[] = [
  { path: '/', redirect: '/ip-management-industry' },
  {
    path: '/ip-management-industry',
    name: 'IPManagementIndustryForm',
    component: () => import('@/pages/topic/IndustryWorkspace.vue'),
    meta: { title: '行业搜索', rail: false },
  },
  {
    path: '/intelligent-agent',
    name: 'IntelligentAgent',
    component: () => import('@/pages/workflow/WorkflowPage.vue'),
    meta: { title: '创作工作流', step: 'copywriting' },
  },
  {
    path: '/__cmp-preview',
    name: 'CmpPreview',
    component: () => import('@/pages/preview/CmpPreview.vue'),
    meta: { title: '皮肤预览' },
  },
  {
    path: '/topic-feed',
    name: 'TopicFeed',
    component: () => import('@/pages/topic/TopicFeed.vue'),
    meta: { title: '爆款选题', step: 'topic' },
  },
  {
    path: '/tasks',
    name: 'TaskCenter',
    component: () => import('@/pages/tasks/TaskCenter.vue'),
    meta: { title: '任务中心' },
  },
  { path: '/:pathMatch(.*)*', redirect: '/ip-management-industry' },
];
